import { ArrowUp } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AnalystMark } from "./ChatMessage";
import { askJarvis, JARVIS_STARTERS } from "../jarvis";

/** Agency overview's Jarvis box: a question typed here opens Jarvis and asks it. */
export default function JarvisAsk() {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const ask = (q: string) => { if (q.trim()) navigate(askJarvis(q)); };
  return (
    <section className="jarvis-ask" aria-label="Ask Jarvis">
      <form className="jarvis-ask-form" onSubmit={(e) => { e.preventDefault(); ask(text); }}>
        <AnalystMark />
        <label htmlFor="jarvis-ask-input" className="sr-only">Ask Jarvis</label>
        <input id="jarvis-ask-input" value={text} maxLength={4000} onChange={(e) => setText(e.target.value)} placeholder="Ask Jarvis about the agency…" autoComplete="off" />
        <button type="submit" className="ac-send" disabled={!text.trim()} aria-label="Ask Jarvis"><ArrowUp aria-hidden="true" /></button>
      </form>
      <div className="jarvis-ask-starters">
        {JARVIS_STARTERS.slice(0, 3).map((q) => <button key={q} type="button" onClick={() => ask(q)}>{q}</button>)}
        <Link to="/jarvis">Past conversations</Link>
      </div>
    </section>
  );
}
